import { put } from 'redux-saga/effects';
import EasyRedux from '../../../utils/EasyRedux';
import handleSagaError from '../../handleSagaError';

const key = 'BLOG/COMMENTS';

export const { actionTypes, actions, reducer } = new EasyRedux(key);

export function* watchGetBlogCommentsList(
  client,
  { payload: { siteId, resolve, reject } }
) {
  try {
    const response = yield client.post('/merchant/review/list', {
      data: {
        site: siteId,
        ft: 1, // 1: blog reviews (our case), 0: business reviews
        so: -1, // sort based on date (latest on top)
      },
    });

    yield put(actions.loadSuccess(response.result.data));
    resolve && resolve(response.result.data);
  } catch (e) {
    reject && reject(e);
    yield put(actions.loadFailure(e));
    yield handleSagaError(e);
  }
}

export default reducer;
